var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 80,
    viewBox: "0 0 289 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.097 49.2749C125.298 50.4805 126.717 51.429 128.353 52.124C129.99 52.819 131.81 53.1836 133.771 53.1913C135.224 53.1913 136.643 52.9725 137.989 52.4964C139.334 52.0549 140.569 51.4366 141.697 50.5957C142.791 49.7932 143.735 48.8065 144.534 47.6738C145.334 46.5449 145.915 45.3008 146.278 43.9147H140.569C140.317 44.5713 139.954 45.1549 139.48 45.6656C139.006 46.1763 138.463 46.6141 137.843 46.9443C137.224 47.309 136.608 47.6008 135.916 47.7851C135.224 47.9656 134.498 48.0769 133.771 48.0769C132.536 48.0769 131.408 47.8581 130.426 47.4204C129.405 47.0211 128.533 46.4374 127.806 45.6695C127.08 44.9015 126.537 44.0261 126.135 43.0393C125.738 42.0563 125.554 40.9582 125.554 39.7909C125.554 38.6237 125.734 37.5294 126.135 36.5426C126.533 35.5558 127.08 34.6803 127.806 33.9124C128.537 33.1444 129.408 32.5608 130.426 32.1231C131.408 31.7199 132.536 31.501 133.771 31.501C134.498 31.501 135.224 31.6085 135.916 31.7928C136.608 31.9733 137.224 32.2652 137.843 32.5954C138.463 32.9601 139.006 33.3978 139.48 33.9085C139.95 34.4192 140.313 35.0028 140.569 35.6594H146.278C145.915 34.2733 145.334 32.9947 144.534 31.862C143.735 30.7293 142.787 29.7809 141.697 28.94C140.569 28.1337 139.334 27.5155 137.989 27.0394C136.643 26.6017 135.224 26.3828 133.771 26.3828C131.806 26.3828 129.99 26.7092 128.353 27.4041C126.717 28.0991 125.298 29.0475 124.097 30.2531C122.897 31.4588 121.952 32.8834 121.26 34.5267C120.572 36.1701 120.243 37.921 120.243 39.7832C120.243 41.6455 120.568 43.3963 121.26 45.0397C121.952 46.6831 122.897 48.0692 124.097 49.2749Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.677 38.7641C89.9136 38.0677 88.9708 37.5213 87.9174 37.1173C86.8295 36.7171 85.6692 36.5324 84.3982 36.5286H77.0201V31.846H90.9671V26.7979H71.7222V52.7772H84.3982C85.6654 52.7772 86.8295 52.558 87.9174 52.154C88.9708 51.7538 89.9136 51.2035 90.677 50.4725C91.4404 49.7761 92.0549 48.8988 92.5282 47.91C92.9634 46.925 93.1809 45.863 93.1809 44.6549C93.1809 43.4467 92.9634 42.3501 92.5282 41.3613C92.0549 40.3724 91.4404 39.4952 90.677 38.7641ZM84.3257 41.3997C85.4517 41.3997 86.3563 41.6922 87.0472 42.2424C87.738 42.7888 88.0625 43.5929 88.0625 44.6549C88.0625 45.7168 87.738 46.4825 87.0472 47.0327C86.3563 47.5829 85.4517 47.8753 84.3257 47.8753H77.0201V41.3997H84.3257Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.619 26.8086V37.3824H170.163L176.218 29.773V37.3824H177.989V26.8086H176.444L170.405 34.4052V26.8086H168.619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.746 31.8126L155.992 26.8096H154.373V37.3834H156.143V29.7868L159.762 34.598L163.35 29.8022V37.3834H165.136V26.8096H163.516L159.746 31.8126Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.886 33.7197H183.235V37.3824H181.464V26.8086H184.886C187.095 26.8086 188.608 28.3126 188.608 30.2641C188.608 32.2157 187.095 33.7197 184.886 33.7197ZM184.87 28.4481H183.235V32.0827H184.87C186.141 32.0827 186.869 31.2924 186.869 30.2667C186.869 29.2359 186.141 28.4481 184.87 28.4481Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.373 41.6895V52.2632H155.917L161.972 44.6539V52.2632H163.742V41.6895H162.198L156.159 49.286V41.6895H154.373Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.218 41.6895H168.988V46.0683H174.302V41.6895H176.073V52.2632H174.302V47.7207H168.988V52.2632H167.218V41.6895Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.268 41.6895H179.56V52.2632H183.738C185.782 52.2632 187.204 50.9076 187.204 49.1658C187.204 47.8562 186.46 47.0505 185.477 46.649C186.068 46.2167 186.476 45.5619 186.476 44.6079C186.476 43.0144 185.191 41.6895 183.268 41.6895ZM184.736 44.7127C184.736 45.5312 184.146 46.1425 183.177 46.1425H181.331V43.2829H183.177C184.146 43.2829 184.736 43.9377 184.736 44.7127ZM185.477 49.1505C185.477 50.0431 184.843 50.6698 183.691 50.6698H181.331V47.6311H183.691C184.84 47.6311 185.477 48.2706 185.477 49.1505Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.015 41.6895H196.478V43.3571H191.786V46.0683H195.571V47.736H191.786V50.5956H196.478V52.2632H190.015V41.6895Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.073 41.5107C200.865 41.5107 198.474 43.8792 198.474 46.9767C198.474 50.0741 200.865 52.4426 204.073 52.4426C206.66 52.4426 208.719 50.7878 209.25 48.7185H207.341C206.886 49.9258 205.584 50.7596 204.071 50.7596C201.832 50.7596 200.257 49.1073 200.257 46.9767C200.257 44.8461 201.83 43.1938 204.071 43.1938C205.587 43.1938 206.886 44.0276 207.341 45.2349H209.25C208.722 43.1631 206.663 41.5107 204.073 41.5107Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.061 43.3571H210.941V41.6895H218.964V43.3571H215.832V52.2632H214.061V43.3571Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.481 41.6895V52.2632H223.025L229.08 44.6539V52.2632H230.851V41.6895H229.307L223.267 49.286V41.6895H221.481Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.076 50.5956V54.468H242.44V52.2632H234.326V41.6895H236.113V50.5956H240.927V41.6895H242.713V50.5956H244.076Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.759 41.6895V52.2632H248.303L254.358 44.6539V52.2632H256.129V41.6895H254.584L248.545 49.286V41.6895H246.759Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.606 52.2632V41.6894H261.392V49.286L267.432 41.6894H268.976V52.2632H267.206V44.6538L261.151 52.2632H259.606Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261.923 38.5459H263.087C263.087 39.4386 263.602 39.991 264.434 39.991C265.266 39.991 265.781 39.4411 265.781 38.5459H266.946C266.946 40.0652 265.825 41.0193 264.432 41.0193C263.043 41.0193 261.923 40.0652 261.923 38.5459Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.07 52.7772H97.9944V26.7979H103.07V37.8099L112.096 26.7979H118.406L108.11 39.2758L120.554 52.7772H113.927L103.07 40.9958V52.7772Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0473 60C52.1061 60 61.071 51.0457 61.071 40C61.071 28.9543 52.1061 20 41.0473 20C29.9886 20 21.0237 28.9543 21.0237 40C21.0237 51.0457 29.9886 60 41.0473 60Z",
    fill: "url(#paint0_linear_3_862)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.107 23.4152C23.4499 29.4636 24.1724 40.3612 31.7227 47.7531C39.2704 55.145 50.7851 56.2366 57.4449 50.1856C58.1994 49.5 58.8592 48.7523 59.425 47.9545C60.4841 45.5167 61.0713 42.8268 61.0713 40C61.0713 28.9543 52.1064 20 41.0476 20C37.3255 20 33.8406 21.0144 30.8548 22.7815C30.5994 22.9832 30.35 23.1944 30.107 23.4152Z",
    fill: "url(#paint1_radial_3_862)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4665 23.414C28.3157 28.207 31.9851 35.6557 39.6635 40.0465C47.3419 44.4399 56.1179 44.1139 59.2714 39.3182C60.1619 37.9639 60.5083 36.398 60.374 34.7492C58.0651 26.2506 50.2871 20 41.0476 20C38.2573 20 35.6003 20.5701 33.1869 21.5999C32.5073 22.1088 31.9268 22.7137 31.4665 23.414Z",
    fill: "url(#paint2_radial_3_862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_862",
    x1: 51.8662,
    y1: 84.859,
    x2: 38.2646,
    y2: -5.57742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3_862",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.993 41.7105) rotate(106.278) scale(36.1876 30.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3_862",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.783 12.6694) rotate(53.1036) scale(50.7038 56.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.8f29e9011b455f74b4ee5f5f3b223eec.svg";
export { ForwardRef as ReactComponent };